"use client";

import { c as _c } from "react/compiler-runtime";
import type { ProductCollectionSortItem, ProductSortItem } from "@repo/graphql-shopify-storefront";
import type { Usable } from "react";
import type { ResolvedIntlConfig } from "react-intl";
import { env } from "#/utilities/env";
import { useGetIntl } from "@repo/i18n/intl/client";
import { cn } from "@repo/lib";
import { useSearchParams } from "next/navigation";
import { RefineBy } from "#/components/molecules/search-refinements/refine-by";
import { RefineBySortByQueryParameterItem } from "#/components/molecules/search-refinements/refine-by-sort-by-query-parameter-item";
export function SortBy(t0) {
  const $ = _c(19);
  const {
    className,
    defaultSort,
    dictionaryPromise,
    lang,
    sortItems,
    title
  } = t0;
  let t1;
  if ($[0] !== dictionaryPromise || $[1] !== lang) {
    t1 = {
      dictionaryPromise,
      lang
    };
    $[0] = dictionaryPromise;
    $[1] = lang;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const intl = useGetIntl(t1);
  const searchParams = useSearchParams();
  let t2;
  if ($[3] !== defaultSort || $[4] !== searchParams || $[5] !== sortItems) {
    t2 = sortItems.find(sortItem => sortItem.slug === searchParams?.get("sort"))?.title ?? defaultSort.title;
    $[3] = defaultSort;
    $[4] = searchParams;
    $[5] = sortItems;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const active = t2;
  let t3;
  if ($[7] !== className) {
    t3 = cn({
      hidden: env.NEXT_PUBLIC_FEATURE_FLAG_SEARCH_COLLECTIONS_ENABLE !== true
    }, className);
    $[7] = className;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== intl || $[10] !== title) {
    t4 = title ?? intl.formatMessage({
      defaultMessage: "Sort by",
      description: "Title for sort by section",
      id: "sb2U9s"
    });
    $[9] = intl;
    $[10] = title;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== sortItems) {
    t5 = sortItems.map(_temp);
    $[12] = sortItems;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== active || $[15] !== t3 || $[16] !== t4 || $[17] !== t5) {
    t6 = <RefineBy active={active} className={t3} title={t4}>{t5}</RefineBy>;
    $[14] = active;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}
function _temp(item) {
  return <RefineBySortByQueryParameterItem key={item.title} item={item} />;
}